import { render } from "./NotFound.vue?vue&type=template&id=331c22ae"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=331c22ae&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "331c22ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('331c22ae', __exports__)) {
    api.reload('331c22ae', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=331c22ae", () => {
    api.rerender('331c22ae', render)
  })

}


export default __exports__